import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Rewind = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Rewind" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M21.4141 2.68946C21.7184 2.46969 22.1208 2.4386 22.4551 2.60939C22.7894 2.78033 23 3.12452 23 3.50001V20C23 20.3688 22.7968 20.7078 22.4717 20.8818C22.1466 21.0557 21.7521 21.0366 21.4453 20.832L14 15.8682V20C14 20.3761 13.7892 20.7209 13.4541 20.8916C13.119 21.0623 12.7163 21.0298 12.4121 20.8086L1.41211 12.8086C1.15339 12.6204 1 12.3199 1 12C1.00003 11.6801 1.15339 11.3796 1.41211 11.1914L12.4121 3.19142C12.7163 2.97031 13.119 2.93778 13.4541 3.10841C13.7892 3.27908 14 3.62395 14 4.00001V8.04396L21.4141 2.68946ZM13.5859 10.8106C13.2816 11.0304 12.8792 11.0615 12.5449 10.8906C12.2106 10.7197 12 10.3755 12 10V5.9629L3.69922 12L12 18.0361V14C12 13.6313 12.2032 13.2922 12.5283 13.1182C12.8534 12.9443 13.2479 12.9635 13.5547 13.168L21 18.1309V5.45509L13.5859 10.8106Z" fill="#000" />
  </StyledIcon>
));

Rewind.displayName = 'Rewind';

export { Rewind };
